import { Grid, Stack, Typography } from "@mui/material";
import WushCard from "../../layout/WushCard";

export default function CreditCard({ card, onClick, selected }) {
  return (
    <Stack>
      <WushCard
        onClick={onClick}
        border={selected && "1px solid rgba(0, 0, 0, 1)"}
      >
        <Stack p={2} width="100%">
          <Grid container>
            <Grid item sm={12}>
              <Stack textAlign="right" width="100%">
                <Typography>{card.brand.toUpperCase()}</Typography>
              </Stack>
              <Stack direction="row" spacing={2}>
                <Typography>xxxx xxxx xxxx {card.last4}</Typography>
                <Typography color="lightgrey">Exp: {card.exp_month} / {card.exp_year}</Typography>
              </Stack>
            </Grid>
            {/* {handleDelete && <Grid item sm={2} textAlign="right">
              <DeleteConfirmation
                handleDelete={handleDelete}
              >
                <IconButton size="small">
                  <Delete />
                </IconButton>
              </DeleteConfirmation>
            </Grid>} */}
          </Grid>

        </Stack>
      </WushCard>
    </Stack>
  );
}